// CRM-NANCOZI — Page de connexion
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login, clearError } from '../store/slices/authSlice';
import { Lock, Mail, Loader } from 'lucide-react';
import bgImage from '../img/2.jpg';
import logo from '../img/logo1.png';

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector(s => s.auth);

  const { register, handleSubmit, formState: { errors } } = useForm();

  useEffect(() => {
    if (error) { dispatch(clearError()); }
  }, [error, dispatch]);

  const onSubmit = async (data) => {
    const result = await dispatch(login(data));
    if (login.fulfilled.match(result)) {
      navigate('/welcome');
    } else {
      // L'erreur est déjà dans Redux state (s.auth.error), affichée en rouge sous le formulaire
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
      padding: '0px 380px', position: 'relative',
    }}>
      <div style={{
        background: 'white', borderRadius: 16, padding: '40px 36px',
        width: '100%', maxWidth: 480, boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
      }}>
        {/* Logo + Titre */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img
            src={logo}
            alt="NANCOZI CORPORATION"
            style={{
              width: 90, height: 90, objectFit: 'contain',
              borderRadius: 16, margin: '0 auto 16px', display: 'block',
              boxShadow: '0 4px 16px rgba(31,78,121,0.2)'
            }}
          />
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1F4E79', margin: 0 }}>CRM-NANCOZI</h1>
          <p style={{ color: '#6B7280', fontSize: 13, marginTop: 4 }}>
            Gestion de la Relation Client — NANCOZI CORPORATION
          </p>
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="form-label">Adresse email</label>
            <div style={{ position: 'relative' }}>
              <Mail size={16} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }} />
              <input
                {...register('email', {
                  required: "L'email est obligatoire",
                  pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Email invalide' }
                })}
                type="email"
                placeholder="votre@email.com"
                className={`form-control ${errors.email ? 'error' : ''}`}
                style={{ paddingLeft: 38 }}
                autoComplete="email"
              />
            </div>
            {errors.email && <p className="form-error">{errors.email.message}</p>}
          </div>

          <div className="form-group">
            <label className="form-label">Mot de passe</label>
            <div style={{ position: 'relative' }}>
              <Lock size={16} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }} />
              <input
                {...register('password', { required: 'Le mot de passe est obligatoire' })}
                type="password"
                placeholder="••••••••"
                className={`form-control ${errors.password ? 'error' : ''}`}
                style={{ paddingLeft: 38 }}
                autoComplete="current-password"
              />
            </div>
            {errors.password && <p className="form-error">{errors.password.message}</p>}
          </div>

          <button
            type="submit"
            className="header-btn btn-primary w-full"
            disabled={loading}
            style={{ justifyContent: 'center', padding: '11px 20px', fontSize: 14, marginTop: 8, width: '100%' }}
          >
            {loading ? <><Loader size={16} style={{ animation: 'spin 1s linear infinite' }} /> Connexion...</> : 'Se connecter'}
          </button>

          {error && (
            <div style={{
              marginTop: 14, padding: '10px 14px',
              background: '#FCE4EC', border: '1px solid #C00000',
              borderRadius: 8, color: '#C00000',
              fontSize: 13, fontWeight: 500, textAlign: 'center',
            }}>
              {error}
            </div>
          )}
        </form>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <a href="/reset-password" style={{ fontSize: 13, color: '#2E75B6', textDecoration: 'none' }}>
            Mot de passe oublié ?
          </a>
        </div>
      </div>
    </div>
  );
}
